// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3CDmM","inner":"Form_inner__1qvhM","range":"Form_range__g16O_","name":"Form_name__3Vgy3","actions":"Form_actions__n_mT4"};